<ng-container *ngIf="isSupportedColour; else simpleText">
	<div class="status-cell-container full-size" (click)="togglePopup()" [tooltip]="enableTooltip ? statusTooltipContent : null" [tooltip-hover]="true" [tooltip-position]="'top'">
		<div [ngClass]="isAof || (!isAof && !statusChange) || isSuggestedAddition ? 'icon-container' : 'icon-container-with-arrow'">
			<div class="status-change-icon-container">
				<dz-icon *ngIf="statusChange && !isSuggestedAddition" class="status-change-icon" [type]="statusChangeIcon"></dz-icon>
			</div>
			<div class="status-icon-container" [ngClass]="{ aof: isAof }">
				<img [remote-src]="statusIconSrc" />
			</div>
		</div>

		<div *ngIf="enableStatusInteractions && showEditButton" class="status-interaction-button">
			<dz-icon #icon type="pencil-alt"></dz-icon>
		</div>
	</div>
</ng-container>

<ng-template #simpleText>
	{{ value }}
</ng-template>

<ng-template #statusTooltipContent>
	<div class="tooltip-content">
		<div>
			<span dcrHTMLKey="FUND_ANALYSIS_CURRENT_STATUS_TOOLTIP" class="tooltip-text-bold">Current Status </span>
			<span dcrHTMLKey="FUND_ANALYSIS_AS_OF_DATE_TOOLTIP" class="tooltip-text">as of: </span>
			<span class="tooltip-text">{{ asOfDate }} </span>
		</div>
		<div class="padding-bottom-8 tooltip-status-container">
			<img class="icon" [remote-src]="tooltipStatusIconSrc" />
			<span class="tooltip-text" [dcrHTMLKey]="'FUND_ANALYSIS_STATUS_TOOLTIP_' + statusColour"></span>
		</div>

		<ng-container *ngIf="statusChange">
			<div>
				<span dcrHTMLKey="FUND_ANALYSIS_PREVIOUS_STATUS_TOOLTIP" class="tooltip-text-bold">Previous Status </span>
				<span dcrHTMLKey="FUND_ANALYSIS_AS_OF_DATE_TOOLTIP" class="tooltip-text">as of: </span>
				<span class="tooltip-text">{{ asOfDateCompare }} </span>
			</div>
			<div class="padding-bottom-8 tooltip-status-container">
				<img class="icon" [remote-src]="tooltipStatusComparisonIconSrc" />
				<span class="tooltip-text" [dcrHTMLKey]="'FUND_ANALYSIS_STATUS_TOOLTIP_' + comparisonStatusColour"> </span>
			</div>
		</ng-container>

		<div class="tooltip-text" [dcrHTMLKey]="'FUND_ANALYSIS_STATUS_TOOLTIP_LAUNCH'">Click to launch the fund modal and learn more.</div>
	</div>
</ng-template>
